



































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ApiPermissions } from '@/core/security/Permissions';
import { ModalConstants } from '@/core/constants';
import { AdminApi } from '@/services/api/api.admin';
import { User } from '@/models/user/user.model';
import { UpdateUserPasswordRequest } from '@/types/apiServerContract';

@Component
export default class EditWebsitePassword extends Vue {
	@Prop({ required: true }) user!: User;

	id: string = ModalConstants.ChangeWebsitePassword;
	permissions: string[] = [ApiPermissions.User.EditWebsitePassword];

	password: string = '';
	passwordConfirm: string = '';
	loading: boolean = false;

	ChangePassword() {
	    this.loading = true;

	    const request: UpdateUserPasswordRequest = {
	        userId: this.user.id,
	        password: this.password
	    };

	    AdminApi.UpdateWebsitePassword(request)
	        .then(result => {
	            this.$bvModal.hide(this.id);
	            this.$bvToast.toast(`${this.user.userName}'s password has been changed successfully`, {
	                variant: 'success',
	                title: 'Success'
	            });
	        })
	        .finally(() => (this.loading = false));
	}

	Reset() {
	    this.password = '';
	    this.passwordConfirm = '';
	    this.$nextTick(() => {
	        (this.$refs.Validator as any).reset();
	    });
	}
}
